/* Generated by restful-react */

import React from 'react'
import { Get, GetProps, useGet, UseGetProps } from 'restful-react'

export const SPEC_VERSION = 'v1'
export interface DedicatedLanesFilters {
  pickupCity?: string | null
  pickupStateCode?: string | null
  pickupLoadMethod?: 'drop' | 'live' | null
  pickupMiles?: number
  deliveryCity?: string | null
  deliveryStateCode?: string | null
  deliveryLoadMethod?: 'drop' | 'live' | null
  deliveryMiles?: number
  startDate?: string
  endDate?: string
  equipment?: {
    id?: number
  }
  trailerType?: string | null
}

export interface DedicatedLaneFacility {
  stopType?: 'pickup' | 'delivery'
  name?: string
  address?: string
  city?: string
  stateCode?: string
  postalCode?: string
  hours?: {
    open247?: boolean
    sameHoursMonFri?: boolean
    shifts?: {
      day?: 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday'
      /**
       * formatted string hh:mm e.g. 10:30am will be 10:30 & 1:30pm will be 13:30
       */
      startTime?: string
      /**
       * formatted string hh:mm e.g. 10:30am will be 10:30 & 1:30pm will be 13:30
       */
      endTime?: string
      closed?: boolean
    }[]
  }
}

export interface DedicatedLanesResponse {
  id?: number
  averageAmount?: number
  startDate?: string
  endDate?: string
  volume?: number | null
  pickup?: {
    city?: string | null
    stateCode?: string | null
  }
  pickupFacilities?: DedicatedLaneFacility[]
  delivery?: {
    city?: string | null
    stateCode?: string | null
  }
  deliveryFacilities?: DedicatedLaneFacility[]
  equipment?: {
    id?: number
    parentId?: number
    key?: string
    name?: string
  }
  loadingMethod?: 'live-live' | 'live-drop' | 'drop-live' | 'drop-drop'
  listingDetails?: {
    commodity?: string | null
    maxWeight?: number | null
    minWeight?: number | null
    note?: string | null
    offerLeadTime?: number | null
  } | null
  salesRep?: string
  shipperMiles?: number
  volumeType?: 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday'
}

export interface GetDedicatedLanesResponse {
  dedicatedLanes?: DedicatedLanesResponse[]
  page?: number
  pageCount?: number
  totalCount?: number
}

export interface GetDedicatedLanesQueryParams {
  /**
   * Search Filters
   */
  filters?: DedicatedLanesFilters
  /**
   * Current page number
   */
  page?: number
  /**
   * Results per page
   */
  perPage?: number
}

export type GetDedicatedLanesProps = Omit<
  GetProps<GetDedicatedLanesResponse, unknown, GetDedicatedLanesQueryParams, void>,
  'path'
>

/**
 * Search for dedicated lanes
 */
export const GetDedicatedLanes = (props: GetDedicatedLanesProps) => (
  <Get<GetDedicatedLanesResponse, unknown, GetDedicatedLanesQueryParams, void>
    path='/fleet_planner/v1/dedicated_lanes'
    {...props}
  />
)

export type UseGetDedicatedLanesProps = Omit<
  UseGetProps<GetDedicatedLanesResponse, unknown, GetDedicatedLanesQueryParams, void>,
  'path'
>

/**
 * Search for dedicated lanes
 */
export const useGetDedicatedLanes = (props: UseGetDedicatedLanesProps) =>
  useGet<GetDedicatedLanesResponse, unknown, GetDedicatedLanesQueryParams, void>(
    `/fleet_planner/v1/dedicated_lanes`,
    props
  )

export interface GetDedicatedLaneResponse {
  dedicatedLane?: DedicatedLanesResponse
}

export interface GetDedicatedLanePathParams {
  /**
   * ID of dedicated lane
   */
  id: string
}

export type GetDedicatedLaneProps = Omit<
  GetProps<GetDedicatedLaneResponse, unknown, void, GetDedicatedLanePathParams>,
  'path'
> &
  GetDedicatedLanePathParams

/**
 * Get a dedicated lane by id
 */
export const GetDedicatedLane = ({ id, ...props }: GetDedicatedLaneProps) => (
  <Get<GetDedicatedLaneResponse, unknown, void, GetDedicatedLanePathParams>
    path={`/fleet_planner/v1/dedicated_lanes/${id}`}
    {...props}
  />
)

export type UseGetDedicatedLaneProps = Omit<
  UseGetProps<GetDedicatedLaneResponse, unknown, void, GetDedicatedLanePathParams>,
  'path'
> &
  GetDedicatedLanePathParams

/**
 * Get a dedicated lane by id
 */
export const useGetDedicatedLane = ({ id, ...props }: UseGetDedicatedLaneProps) =>
  useGet<GetDedicatedLaneResponse, unknown, void, GetDedicatedLanePathParams>(
    (paramsInPath: GetDedicatedLanePathParams) =>
      `/fleet_planner/v1/dedicated_lanes/${paramsInPath.id}`,
    { pathParams: { id }, ...props }
  )
